import type { Dictionary } from './types';

export const en: Dictionary = {
  'meta.title': 'gAz — grit And zeal',

  'nav.home': 'Home',
  'nav.news': 'News',
  'nav.roster': 'Rosters',
  'nav.achievements': 'Achievements',
  'nav.media': 'Media',
  'nav.join': 'Join the clan',
  'nav.contacts': 'Contacts',
  'nav.history': 'Clan history',
  'nav.admin': 'Admin',
  'nav.collapse': 'Collapse menu',
  'nav.expand': 'Expand menu',
  'nav.menu': 'Menu',
  'nav.language': 'Language',

  'common.loading': 'Loading archive…',
  'common.error': 'Failed to load data.',
  'common.retry': 'Retry',
  'common.empty': 'No records yet.',
  'common.back': 'Back',
  'common.readMore': 'Read',
  'common.all': 'All',
  'common.newest': 'Newest first',
  'common.oldest': 'Oldest first',
  'common.open': 'Open',
  'common.close': 'Close',
  'common.records': 'records',
  'common.record': 'Record',
  'common.section': 'Section',

  'footer.tagline': 'StarCraft II clan. Grit and zeal.',
  'footer.sections': 'Sections',
  'footer.community': 'Community',
  'footer.adminContact': 'Contact the staff',
  'footer.adminContactText': 'Message the clan officers on Discord or Telegram.',
  'footer.rights': 'All rights reserved. StarCraft is a trademark of Blizzard Entertainment.',

  'footer.madeBy': 'Website by',

  'home.kicker': 'StarCraft II · clan',
  'home.title': 'grit And zeal',
  'home.subtitle': 'A team that gathers for the game, stays for the people and comes back for the next matches.',
  'home.ctaMeet': 'Meet the team',
  'home.ctaJoin': 'Join us',
  'home.aboutTitle': 'About the team',
  'home.about1':
    'grit And zeal is an esports team united by a shared game, competitive spirit and the will to grow together.',
  'home.about2':
    'We play, review matches, enter tournaments, share experience and write our own story. To us a team is not just a list of players — it is the people you want to come back to the game with.',
  'home.statRosters': 'rosters',
  'home.statPlayers': 'players',
  'home.statResults': 'results archived',
  'home.latestNews': 'Latest entries',
  'home.allNews': 'All news',
  'home.rostersTitle': 'Rosters',
  'home.allRosters': 'Full roster',
  'home.achievementsTitle': 'Recent results',
  'home.allAchievements': 'All achievements',
  'home.joinTitle': 'Recruiting now',
  'home.joinText': 'Any level, from Bronze to Grandmaster. All it takes is the will to play and grow together.',

  'news.title': 'News',
  'news.lead': 'The clan log: matches, tournaments, announcements and interviews.',
  'news.cat.team': 'Team news',
  'news.cat.results': 'Match results',
  'news.cat.announcements': 'Announcements',
  'news.cat.tournaments': 'Tournaments',
  'news.cat.interviews': 'Interviews',
  'news.related': 'Related posts',
  'news.gallery': 'Gallery',
  'news.video': 'Video',
  'news.links': 'Links',
  'news.notFound': 'Post not found or unpublished.',
  'news.toList': 'All news',

  'roster.title': 'Rosters',
  'roster.lead': 'Five rosters by MMR. Click a nickname to open the player card.',
  'roster.players': 'player|players|players',
  'roster.noPlayers': 'Roster is being formed.',
  'roster.mmrFrom': '{min}+ MMR',
  'roster.mmrTo': 'up to {max} MMR',
  'roster.mmrRange': '{min}–{max} MMR',
  'roster.filter.from': 'from',
  'roster.filter.to': 'to',
  'roster.filter.reset': 'Reset filters',
  'roster.filter.found': 'Found',
  'roster.filter.none': 'No players match the selected filters.',

  'player.race': 'Race',
  'player.role': 'Role',
  'player.pulse': 'SC2: Pulse',
  'player.openPulse': 'SC2 Pulse profile',
  'player.mmr': 'MMR',
  'player.roster': 'Roster',
  'player.battleTag': 'BattleTag',
  'player.country': 'Country',
  'player.notFound': 'Player not found.',
  'player.toRoster': 'Back to rosters',
  'player.card': 'Player card',
  'race.protoss': 'Protoss',
  'race.terran': 'Terran',
  'race.zerg': 'Zerg',
  'race.random': 'Random',
  'role.member': 'Member',
  'role.officer': 'Officer',
  'role.leader': 'Clan leader',

  'ach.title': 'Achievements',
  'ach.lead': 'A timeline of wins and results. The full archive is kept — from the first tournaments to the latest.',
  'ach.event': 'Event',
  'ach.date': 'Date',
  'ach.mmr': 'MMR',
  'ach.place': 'Place',
  'ach.source': 'Results',
  'ach.vod': 'VOD',

  'media.title': 'Media',
  'media.lead': 'Library of recordings and materials: streams, matches, highlights, screenshots and photos.',
  'media.type.stream': 'Stream VODs',
  'media.type.match': 'Match videos',
  'media.type.highlight': 'Highlights',
  'media.type.screenshot': 'Screenshots',
  'media.type.photo': 'Photos',
  'media.search': 'Search by title',
  'media.nothingFound': 'Nothing found.',

  'join.kicker': 'Recruitment',
  'join.title': 'Application to join gAz',
  'join.text':
    'We are always open to new members. Fill in the application — we will review it and contact you via the method you provide.',
  'join.nickname': 'In-game nickname',
  'join.profile': 'Game profile link',
  'join.profileHint': 'Battle.net, SC2 Pulse or RankedFTW',
  'join.mmr': 'MMR',
  'join.timezone': 'Time zone',
  'join.contact': 'Discord or other contact',
  'join.contactHint': 'Discord name, @telegram or a link',
  'join.comment': 'Additional comment',
  'join.commentHint': 'Race, experience, what you expect from the clan',
  'join.submit': 'Send application',
  'join.sending': 'Sending…',
  'join.successTitle': 'Application sent',
  'join.successText': 'Thank you! We received your application and will reach out via the contact you provided soon.',
  'join.again': 'Send another one',
  'join.rateLimited': 'Too many applications from this address. Please try later.',
  'join.invalid': 'Please check the form: {error}',
  'join.failed': 'Could not send the application. Try again or message us on Discord.',
  'join.required': 'required',
  'join.steps': 'What happens next',
  'join.step1': 'Officers review your application',
  'join.step2': 'We contact you on Discord / Telegram',
  'join.step3': 'Introduction and roster placement by MMR',

  'contacts.title': 'Contacts',
  'contacts.lead': 'Where the clan lives: chat, streams, videos and tournaments.',
  'contacts.discord': 'Main clan server: chat, practice, custom games and voice.',
  'contacts.telegram': 'News and announcements channel.',
  'contacts.twitch': 'Streams of clan wars, tournaments and internal events.',
  'contacts.youtube': 'Stream VODs, reviews and highlights.',
  'contacts.challonge': 'Brackets of our tournaments and internal competitions.',
  'contacts.admin': 'Staff',
  'contacts.adminText': 'For partnerships, tournaments and clan wars, message the clan officers on Discord.',

  'history.kicker': 'Clan chronicle',
  'history.hint': 'Click the screen or use arrow keys',
  'history.s1.title': 'Origins',
  'history.s1.text':
    'The clan was born in the StarCraft 2 community as an ambitious project by ModkoW. The name **gAz** stands for **"grit And zeal"**. It defined the team\'s character: take ladder losses with grit, learn from mistakes and polish build orders with zeal.',
  'history.s2.title': 'Growth',
  'history.s2.text':
    'Moving from idea to practice, the clan grew fast and soon passed **30+ regular members**. The key was a comfortable, non-toxic atmosphere. Inside gAz the lines between ranks blurred: Diamond and Master players began running joint practice, custom training matches and reviewing newcomers\' replays. The clan stopped being just a tag in the game.',
  'history.s3.title': 'Esports',
  'history.s3.text':
    'Over time gAz made a name on the community\'s competitive scene. The team began regularly playing **clan wars** against other well-known teams. To raise the bar even higher, gAz leadership started organizing exclusive **masterclasses with professional players**, taking its members to a new level.',
  'history.s4.title': 'Today',
  'history.s4.text':
    'Today gAz is firmly established as **one of the most active, open and friendly young StarCraft 2 communities**. Its players take part in all kinds of tournaments and events. The clan lives an active life on Discord and Telegram, runs its own internal events and keeps recruiting players ready to grow under the grit And zeal banner.',
  'history.restart': 'From the start',
  'history.join': 'Join the clan',
  'history.prev': 'Back',
  'history.next': 'Next',
  'history.chapter': 'Chapter',

  'live.title': 'Live now',
  'live.clan': 'Clan channel',
  'live.watch': 'Watch on Twitch',
  'live.viewers': 'viewer|viewers|viewers',

  'admin.title': 'Archive control',
  'admin.lead': 'Create and edit news, achievements, media and rosters.',
  'admin.email': 'Email',
  'admin.password': 'Password',
  'admin.signIn': 'Sign in',
  'admin.signingIn': 'Signing in…',
  'admin.logout': 'Sign out',
  'admin.badCredentials': 'Wrong email or password.',
  'admin.notAdmin': 'This account has no admin rights.',
  'admin.tab.news': 'News',
  'admin.tab.achievements': 'Achievements',
  'admin.tab.media': 'Media',
  'admin.tab.rosters': 'Rosters',
  'admin.tab.players': 'Players',
  'admin.tab.applications': 'Applications',
  'admin.new': 'Add',
  'admin.edit': 'Edit',
  'admin.delete': 'Delete',
  'admin.save': 'Save',
  'admin.cancel': 'Cancel',
  'admin.saved': 'Saved',
  'admin.deleted': 'Deleted',
  'admin.confirmDelete': 'Delete "{name}"?',
  'admin.upload': 'Upload',
  'admin.uploading': 'Uploading…',
  'admin.draft': 'draft',
  'admin.addLink': 'Add link',
  'admin.status.new': 'New',
  'admin.status.accepted': 'Accepted',
  'admin.status.rejected': 'Rejected',
  'admin.status.archived': 'Archived',
  'admin.noRoster': '— no roster —',
};
